/* React */
import React from "react";

/* Components */
import InfoIconWrapper from "src/utils/wrapper/info-icon-wrapper/InfoIconWrapper";
import ContentContainer from "src/components/chart-wrapper/toolbar/options/survival-plot-options/content-container/ContentContainer";

/* Stylesheet */
import styles from "./SurvivalPlotOptions.module.scss";

const SurvivalPlotOptions: React.FC = () => {
  return (
    <div className={styles.survival_plot_options}>
      <InfoIconWrapper>
        <ContentContainer />
      </InfoIconWrapper>
    </div>
  );
};

export default SurvivalPlotOptions;
